export const URL_CHECK = [
    {
        url: "eneb.nubi",
        id: "0",
        check: "firstTimeEneb",
        domain: "ENEB"
    },
    {
        url: "ctti.nubi",
        id: "1315",
        check: "firstTimeCtii",
        domain: "CTTI" 
    },
    {
        url: "iseb.nubi",
        id: "0",
        check: "firstTimeIseb",
        domain: "ISEB" 
    },
    {
        url: "iead.nubi",
        id: "0",
        check: "firstTimeIead",
        domain: "IEAD" 
    },
    {
        url: "esie.nubi",
        id: "0",
        check: "firstTimeEsie",
        domain: "ESIE" 
    },
    {
        url: "localhost",
        id: "1",
        check: "firstTimeLocalHost",
        domain: "HOST" 
    },
];